import type { PaymentCompletedData, PaymentFailedData } from '@adyen/adyen-web';

import LinkButton from '@sats-group/fresh-fitness-ui-lib/react/link-button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import React, { useRef, useState } from 'react';

import useAdyenDropin from 'root/client/components/adyen-dropin/adyen-dropin';
import Banner from 'root/client/components/banner/banner';
import ContentContainer from 'root/client/components/content-container/content-container';
import PaymentSummary from 'root/client/components/payment-summary/payment-summary';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type { CheckoutPayment as Props } from './checkout-payment.types';

const CheckoutPayment: React.FC<Props> = ({
  actions,
  campaignBlock,
  layout,
  messages,
  payment,
  paymentInformation,
  paymentMethodTitle,
  paymentSummary,
}) => {
  const [localMessages, setLocalMessages] = useState<
    Parameters<typeof Banner>[0][]
  >([]);
  const dropinRef = useRef<HTMLDivElement>(null);
  const config = {
    clientKey: payment.clientKey,
    environment: payment.environment,
    locale: 'no',
    session: payment.session,
    onPaymentCompleted: (data: PaymentCompletedData) => {
      setLocalMessages([messages.paymentComplete[data.resultCode]]);

      window.location.assign(payment.nextHref);
    },
    onPaymentFailed: (data: PaymentFailedData) => {
      setLocalMessages([messages.paymentComplete[data.resultCode]]);
    },
  };

  useAdyenDropin({
    dropinRef,
    config,
    supportGooglePay: payment.supportGooglePay,
  });

  return (
    <SalesLayout {...layout}>
      <ContentContainer width={ContentContainer.widths.Wide}>
        <div className="checkout-payment">
          <noscript>
            <Banner {...messages.noscript} />
          </noscript>
          <div className="checkout-payment__messages">
            {campaignBlock ? <Banner {...campaignBlock} /> : null}
            {localMessages.map(entry => (
              <div key={entry.text}>
                <Banner {...entry} />
              </div>
            ))}
          </div>
          <div className="checkout-payment__content">
            {paymentSummary ? <PaymentSummary {...paymentSummary} /> : null}
            <div className="checkout-payment__payment">
              <Text
                elementName="h2"
                theme={Text.themes.emphasis}
                size={Text.sizes.large}
              >
                {paymentMethodTitle}
              </Text>
              {payment.session ? <div ref={dropinRef} /> : null}
              {paymentInformation ? (
                <Text size={Text.sizes.small}>{paymentInformation}</Text>
              ) : null}
              {actions.length ? (
                <div className="checkout-payment__actions">
                  {actions.map(entry => (
                    <div key={entry.href}>
                      <LinkButton
                        {...entry}
                        theme={LinkButton.themes.secondary}
                        wide
                      />
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ContentContainer>
    </SalesLayout>
  );
};

export default CheckoutPayment;
